
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/marketplaces",
      function () {
        return require("private-next-pages/industry/marketplaces.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/marketplaces"])
      });
    }
  